module.exports = __webpack_public_path__ + "static/media/bg-pattern.08ac4e05.png";